export default __webpack_public_path__ + "static/transportation-9e6444e620ab6e1ebee6fa9764ab314f.png";